import {
  mapActions,
  mapGetters
} from 'vuex'

import {
  BATCH_STATE_OPENED,
  BATCH_STATE_PRINTED,
  BATCH_SOURCE_SYSTEM_WS,
  BATCH_SOURCE_SYSTEM_AOL2
} from '@/enums'

const mixin = {
  data() {
    return {
      samplesFromBatchSelected: {},
      batchCurrentIndex: 0,
      BATCH_STATE_PRINTED,
      BATCH_STATE_OPENED,
      BATCH_SOURCE_SYSTEM_WS,
      BATCH_SOURCE_SYSTEM_AOL2
    }
  },
  methods: {
    ...mapActions([
      'setWaitingBatchesLoadingStatus',
      'batchGetBatches',
      'clearAllBatchesData',
    ])
  },
  computed: {
    ...mapGetters([
      'batchesLoadingStatus',
      'batchesPrintingStatus',
    ]),
  },
  watch: {
    batchesPrintingStatus(newValue) {
      if (newValue === 'STATUS_INITIAL') {
        if (this.$route.name === 'Impressão de Etiquetas - Lotes') {
          this.clearAllBatchesData()
          this.batchGetBatches()
        } else {
          this.loadBatchDetailsData()
        }
      }
    },
    batchesLoadingStatus(newValue) {
      switch (newValue) {
        case 'STATUS_END':
          break
        case 'STATUS_SUCCESS':
          this.setWaitingBatchesLoadingStatus()
          break
        case 'STATUS_FAILED':
          break
        case 'STATUS_INITIAL':
          this.clearAllBatchesData()
          break
        case 'STATUS_WAITING':
          break
        default:
          break
      }
    },
    samplesFromBatchSelected(newVal) {
      this.$emit('update:samplesFromBatchSelected', newVal)
    },
    batchCurrentIndex(newVal) {
      this.$emit('update:batchCurrentIndex', newVal)
    },
    batchSelected(newValue) {
      this.$emit('update:batchSelected', newValue)
    }
  }
}

export default mixin
